import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=549a2a63&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "@/scss/header.scss?vue&type=style&index=0&id=549a2a63&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549a2a63",
  null
  
)

export default component.exports